import { Link as LinkMagik, Pagination, createTable } from "@inmagik/magik-ui"
import { FiltersBase, Immagine } from "../../types"
import { useMemo } from "react"
import { PAGE_SIZE } from "../../constants"
import { Link } from "react-router-dom"

const Table = createTable<Immagine>()

export function TableImmagini({
  immagini,
  setFilters,
  filters,
  count,
  fullCount,
  showEdizione = true,
  actionLink,
}: {
  immagini: Immagine[]
  setFilters: (nextFilters: Partial<FiltersBase>) => void
  filters: FiltersBase
  count: number
  fullCount: number
  showEdizione?: boolean
  actionLink?: (v?: Immagine) => void
}) {
  const numPages = useMemo(() => {
    if (!immagini) {
      return 1
    }
    return Math.ceil(count / PAGE_SIZE)
  }, [immagini, count])

  return (
    <Table
      data={immagini}
      className="w-100 overflow-scroll flex-1"
      orderBy={filters.ordering.replace("-", "")}
      orderDirection={filters.ordering.startsWith("-") ? "desc" : "asc"}
      onOrderChange={(field, direction) => {
        if (field) {
          if (direction === "desc") {
            setFilters({ ...filters, ordering: `-${field}` })
          } else {
            setFilters({ ...filters, ordering: field })
          }
        } else {
          setFilters({ ...filters, ordering: "" })
        }
      }}
    >
      <Table.HeaderConfig sticky />

      <Table.BodyConfig />
      <Table.Column
        title="Titolo"
        name="titolo"
        sortable
        stickyLeft
        width="minmax(max-content, 1fr)"
        render={(immagine) => (
          actionLink ? (
            <LinkMagik className="text-dark" onClick={() => actionLink(immagine)} style={{ cursor: "pointer" }}>
              {immagine.titolo.substring(0,30)}...
            </LinkMagik>
          ) : (
            <Link to={`/edizioni/immagini/${immagine.id}/`}>
              <LinkMagik className="text-dark">{immagine.titolo.substring(0,30)}...</LinkMagik>
            </Link>
          )
        )}
      />
      <Table.Column
        title="Immagine"
        name="immagine"
        sortable
        width="minmax(max-content, 1fr)"
        render={(immagine) => <img src={immagine.immagine_medium} alt={immagine.descrizione} style={{ width: 100 }} />}
      />
      <Table.Column
        title="Tipologia"
        name="tipologia__nome"
        sortable
        width="minmax(max-content, 1fr)"
        render={(immagine) => immagine?.tipologia_data?.nome}
      />
      {showEdizione && (
        <Table.Column
          title="Edizione"
          name="titolo_completo_edizione"
          sortable
          width="minmax(max-content, 1fr)"
          render={(immagine) => <div>{immagine.edizione_data.opera_data.titolo} - {immagine.titolo_completo_edizione}</div>}
        />
      )}

      <Table.Footer.Left>
        Stai visualizzando {count} di {fullCount} immagini
      </Table.Footer.Left>
      <Table.Footer.Center>
        <Pagination page={filters.page} numPages={numPages} onPageChange={(page) => setFilters({ ...filters, page })} />
      </Table.Footer.Center>
    </Table>
  )
}
